export const fieldOption = [
  {
    value: '选项1',
    label: '黄金糕',
  },
  {
    value: '选项2',
    label: '双皮奶',
  },
  {
    value: '选项3',
    label: '蚵仔煎',
  },
  {
    value: '选项4',
    label: '龙须面',
  },
  {
    value: '选项5',
    label: '北京烤鸭',
  },
];
/* BU数据 */
export const BUData = {
  column: [
    {
      title: 'BU名称',
      key: 'labelName',
    },
    {
      title: '状态',
      key: 'enabledName',
    },
  ],
  data: [],
};
/* 领域数据 */
export const fieldData = {
  column: [
    {
      title: '领域名称',
      key: 'labelName',
    },
  ],
  data: [],
};
/* 产品名称 */
export const productData = {
  column: [
    {
      title: '产品名称',
      key: 'labelName',
    },
  ],
  data: [],
};
